import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { Modal, Button, message } from 'antd'
import history from '../../../../history'

import { actions as proposalActions } from '../../../../redux/modules/proposalActions'
import { actions as leadProposalActions } from '../../../../redux/modules/leadFunctions/leadProposalActions'
import { actions as proposalTemplateActions } from '../../../../redux/modules/leadFunctions/proposalTemplateActions'

import LeadProposalView from './LeadProposalView'

import * as authSelectors from '../../../../selectors/auth'
import * as revisionSelectors from '../../../../selectors/revision'
import * as estimatesSelectors from '../../../../selectors/estimates'
import * as proposalsSelectors from '../../../../selectors/lead/proposals'

const propTypes = {
  // from container
  action: PropTypes.string.isRequired,
  contentData: PropTypes.object,
  proposalId: PropTypes.any,

  // selectors
  proposalTemplates: PropTypes.array,
  proposalTemplateSections: PropTypes.array,
  proposalTemplateItems: PropTypes.array,
  proposalItems: PropTypes.array,
  estimateList: PropTypes.array,
  revisions: PropTypes.array,
  loadingRevision: PropTypes.bool,
  proposalMilestonesTemplate: PropTypes.array,
  proposalMilestones: PropTypes.array,

  // actions:
  getProposalTemplateSections: PropTypes.func.isRequired,
  getProposalTemplateItems: PropTypes.func.isRequired,
  getProposalMilestoneTemplate: PropTypes.func.isRequired,
  createLeadProposal: PropTypes.func.isRequired,
  updateLeadProposal: PropTypes.func.isRequired,
  deleteLeadProposal: PropTypes.func.isRequired
}

class AddEditFormModal extends Component {
  state = {
    wrapUpProposal: false
  }

  handleCancel = () => {
    const { leadId } = this.props
    history.push(`/lead/${leadId}/proposals`)
  }

  handleOkButton = () => {
    const { action } = this.props

    if (action === 'add') {
      return 'Create'
    } else if (action === 'edit') {
      return 'Edit'
    } else if (action === 'clone') {
      return 'Clone'
    }
  }

  generateFooter = () => {
    return (
      <div>
        <Button key="save-tmp" type="danger" onClick={() => this.handleFireWrapUpProposal(true)}>
          Save Temporarily
        </Button>
        <Button key="back" onClick={() => this.handleCancel()}>
          Cancel
        </Button>
        <Button key="submit" type="primary" onClick={() => this.handleFireWrapUpProposal(false)}>
          Save
        </Button>
      </div>
    )
  }

  handleChangeWrapUpProposal = () => {
    this.setState({
      wrapUpProposal: !this.state.wrapUpProposal
    })
  }

  getSelectedTemplate = value => {
    const { proposalTemplates } = this.props
    const selectedTemplate = proposalTemplates.find(template => template.name === value)
    return selectedTemplate ? +selectedTemplate.id : +value
  }

  getSelectedEstimate = value => {
    const { estimateList } = this.props
    const selectedEstimate = estimateList.find(
      estimate => `${estimate.id} - ${estimate.description}` === value
    )
    return selectedEstimate ? +selectedEstimate.id : +value
  }

  handleWrapUpProposal = proposal => {
    let proposalInfo = { ...proposal }
    const { saveTemporarily } = this.state
    const { proposalId, action, createLeadProposal, leadId, updateLeadProposal, user } = this.props

    // sanitize the selected template and estimate
    proposalInfo.proposalData.proposal_template_id = this.getSelectedTemplate(
      proposalInfo.proposalData.proposal_template_id
    )
    proposalInfo.proposalData.estimate_id = this.getSelectedEstimate(
      proposalInfo.proposalData.estimate_id
    )

    proposalInfo.proposalData.overview = proposalInfo.proposalData.overview.toString()

    if (saveTemporarily) {
      // save on local storage
      proposalInfo.proposalData.temporary = 1
    } else {
      proposalInfo.proposalData.temporary = 0
    }

    // remove temporary data
    delete proposalInfo.proposalData.estimate_description
    delete proposalInfo.proposalData.proposal_template_name

    if (action === 'add' || action === 'clone') {
      createLeadProposal({
        leadId: this.props.leadId,
        content: proposalInfo.proposalData,
        proposalSections: proposalInfo.proposalSections,
        proposalMilestones: proposalInfo.proposalMilestones,
        userId: user.userId
      })
    } else {
      updateLeadProposal({
        leadId: this.props.leadId,
        proposalId: proposalId,
        content: proposalInfo.proposalData,
        proposalSections: proposalInfo.proposalSections,
        proposalMilestones: proposalInfo.proposalMilestones,
        userId: user.userId
      })
    }

    message.success('Changes saved.')

    history.push(`/lead/${leadId}/proposals`)
    this.setState({
      wrapUpProposal: false,
      saveTemporarily: false,
      cloningMode: false
    })
  }

  loadTemplateData = templateId => {
    const {
      getProposalTemplateSections,
      getProposalTemplateItems,
      getProposalMilestoneTemplate
    } = this.props
    getProposalTemplateSections(templateId)
    getProposalTemplateItems(templateId)
    getProposalMilestoneTemplate({ templateId })
  }

  handleFireWrapUpProposal = saveTemporarily => {
    this.setState({
      wrapUpProposal: true,
      saveTemporarily: saveTemporarily
    })
  }

  handleDeleteProposal = event => {
    const { leadId, proposalId, deleteLeadProposal } = this.props
    deleteLeadProposal({
      leadId: leadId,
      proposalId: proposalId
    })

    message.success('Record deleted.')
    history.push(`/lead/${leadId}/proposals`)
  }

  render() {
    const { wrapUpProposal } = this.state
    const {
      action,
      revisions,
      contentData,
      estimateList,
      proposalItems,
      loadingRevision,
      proposalSections,
      proposalTemplates,
      proposalMilestones,
      proposalTemplateItems,
      proposalTemplateSections,
      proposalMilestonesTemplate
    } = this.props
    return (
      <Modal
        visible={true}
        title={action === 'clone' ? 'CLONING Proposal' : 'Proposal'}
        okText={this.handleOkButton()}
        onCancel={this.handleCancel}
        onOk={this.handleFireWrapUpProposal}
        width="90%"
        footer={this.generateFooter()}
        maskClosable={false}
      >
        <LeadProposalView
          action={action}
          revisions={revisions}
          contentData={contentData}
          estimateList={estimateList}
          proposalItems={proposalItems}
          wrapUpProposal={wrapUpProposal}
          loadingRevision={loadingRevision}
          proposalSections={proposalSections}
          templateItems={proposalTemplateItems}
          proposalTemplates={proposalTemplates}
          estimateInfo={this.state.contentData}
          proposalMilestones={proposalMilestones}
          loadTemplateData={this.loadTemplateData}
          templateSections={proposalTemplateSections}
          handleWrapUpProposal={this.handleWrapUpProposal}
          handleDeleteProposal={this.handleDeleteProposal}
          proposalMilestonesTemplate={proposalMilestonesTemplate}
          handleChangeWrapUpProposal={this.handleChangeWrapUpProposal}
        />
      </Modal>
    )
  }
}

const mapStateToProps = (state, props) => ({
  user: authSelectors.getUser(state, props),
  revisions: revisionSelectors.getRevisions(state, props),
  estimateList: estimatesSelectors.getEstimatesList(state, props),
  proposalItems: proposalsSelectors.getProposalItems(state, props),
  loadingRevision: revisionSelectors.getRevisionsLoading(state, props),
  proposalSections: proposalsSelectors.getProposalSections(state, props),
  proposalTemplates: proposalsSelectors.getProposalTemplates(state, props),
  proposalMilestones: proposalsSelectors.getProposalMilestones(state, props),
  proposalTemplateItems: proposalsSelectors.getProposalTemplateItems(state, props),
  proposalTemplateSections: proposalsSelectors.getProposalTemplateSections(state, props),
  proposalMilestonesTemplate: proposalsSelectors.getProposalMilestonesTemplate(state, props)
})

const mapDispatchToProps = (dispatch, props) => ({
  getProposalTemplateSections: templateId =>
    dispatch(proposalTemplateActions.getProposalTemplateSections(templateId)),
  getProposalTemplateItems: templateId =>
    dispatch(proposalTemplateActions.getProposalTemplateItems(templateId)),
  getProposalMilestoneTemplate: ({ templateId }) =>
    dispatch(proposalActions.getProposalMilestoneTemplate({ templateId })),
  createLeadProposal: ({ leadId, content, proposalSections, proposalMilestones, userId }) =>
    dispatch(
      leadProposalActions.createLeadProposal({
        leadId,
        content,
        proposalSections,
        proposalMilestones,
        userId
      })
    ),
  updateLeadProposal: ({
    leadId,
    proposalId,
    content,
    proposalSections,
    proposalMilestones,
    userId
  }) =>
    dispatch(
      leadProposalActions.updateLeadProposal({
        leadId,
        proposalId,
        content,
        proposalSections,
        proposalMilestones,
        userId
      })
    ),
  deleteLeadProposal: ({ leadId, proposalId }) =>
    dispatch(
      leadProposalActions.deleteLeadProposal({
        leadId,
        proposalId
      })
    )
})

AddEditFormModal.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddEditFormModal))



// WEBPACK FOOTER //
// ./src/pages/lead/components/proposals/AddEditFormModal.component.js